export const BUYING_OPTION_OTP = "otp";
export const BUYING_OPTION_SUBSCRIPTION = "subscription";

export function findProductByName(products, name) {
    if (products === undefined) {
        return null;
    }
    return Object.values(products).find(p => p["id"] === name);
}

export function findCategoryByName(categories, name) {
    if (categories === undefined) {
        return null;
    }
    return Object.values(categories).find(p => p["id"] === name);
}

export function hasVenue(venues, venueId) {
    if (venues === undefined) {
        return null;
    }
    return Object.values(venues).includes(venueId);
}

export const isProductProhibitedForUser = (product, userDetails) =>
    product?.excludedCountries?.includes(userDetails?.deliveryAddress?.country);

export const isAnyProductProhibitedForUser = (basket, productsInfo, userDetails) => {
    return basket?.items?.some(item => {
        const product = findProductByName(productsInfo?.products, item?.product);
        return isProductProhibitedForUser(product, userDetails);
    });
};

export const isCCPaymentProductDisabled = (basket, productsInfo) => {
    return basket?.items?.some(item => {
        const product = findProductByName(productsInfo?.products, item?.product);
        return !product?.order?.creditCard;
    });
};
